import React from 'react';
import { tickerItems } from '../../data/tickerItems';
import './Ticker.css';

function TickerItem({ stat, label }) {
  return (
    <div className="ticker-item">
      {stat && <strong>{stat}</strong>}
      {label}
      <span className="ticker-dot" />
    </div>
  );
}

function Ticker() {
  const repeated = [...tickerItems, ...tickerItems, ...tickerItems];

  return (
    <div className="ticker">
      <div className="ticker-track">
        {repeated.map((item, i) => (
          <TickerItem key={i} stat={item.stat} label={item.label} />
        ))}
      </div>
    </div>
  );
}

export default Ticker;
